<!--
     <TableRow
       :unit="QUnit"
       :qunits="QUnitCollection"
       :columns="qunits.columns"
       :action_list="['Action1']"
       @update="update(QFilters)"
       @update-qunit="update_qunit(new_qunit)"
       @click="qunit_clicked()"
       expandable
       checkbox
       actions
       :expand="() => {}",
       isExpanded,
       isSelected,
       disabled
     />
-->

<template>
  <tr
    :class="'qmkey-item-row' + (isSelected ? ' v-data-table__selected' : '')"
    @click="qunit_clicked"
    :disabled="disabled"
  >
    <!-- Checkbox -->
    
    <!-- HIDDEN UNTILL IT HAS SOME USE -->

    <td v-if="checkbox" @click.stop="qunit_clicked">
      <v-checkbox
        :value="isSelected"
        :input-value="isSelected"
        hide-details
        class="shrink mr-2 mt-0"  
        :disabled="disabled"
      />
    </td>
    

    <!-- Values and actions -->
    <td
      v-for="col in cols"
      :key="unit.uid + col.value"
      :class="'table-row table-row-'+col.value + (is_mobile ? ' mobile-row' : '') "
    >
      <!-- Actions -->
      <Actions
        v-if="actions && col.value == 'action'"
        size="small"
        :unit="unit"
        :action_list="action_list"
        @clicked="action_clicked"
        @update-qunit="update_qunit"
        @refresh="update_qunit_after"
        :disabled="disabled"
      />

      <!-- Column field -->
      <Field
        v-else
        short
        :field="unit.fields[col.value]"
        :navigate="canNavigate ? unit.navigate_list.includes(col.value) : false"
        :is_mobile="is_mobile"
        :disabled="disabled"
        :unit="unit"
        hide_avatar
        @download-evidence="download_file"
        @navigate_to="navigate_to"
      />
    </td>

    <!-- Expand icon -->
    <td v-if="expandable">
      <v-btn
        @click.stop="expand(!isExpanded)"
        icon
        :disabled="disabled"
      >
        <v-icon v-if="isExpanded">mdi-chevron-up</v-icon>
        <v-icon v-else>mdi-chevron-down</v-icon>
      </v-btn>
    </td>
  </tr>
</template>


<style lang="scss">
 @import '@/sass/explorer.scss';
 .table-row-title {
  min-width: 240px;
  .mobile-row {
    min-width: 180px !important;
  }
 }
</style>


<script>
 import QUnit from '@/qunit/QUnit';
 import { QUnitField } from '@/qunit/QFields';
 import QUnitCollection from '@/qunit/QUnitCollection';
 import Field from '@/components/qfields/Field';
 import Actions from '@/components/explorer/actions/Actions';
 import { downloadFile } from '@/utils/browserfiles';
 import QUnitAPI from '@/api/QUnit'
 import { QFilters } from '@/qunit/filters';

 export default {
   name: 'TableRow',

   components: {
     Field,
     Actions,
   },

   props: {
     unit: {required: true},
     qunits: {required: true},
     columns: {required: true},
     checkbox: {type: Boolean, default: false},
     actions: {type: Boolean, default: false},
     action_list: {default: () => ([])},
     expandable: {type: Boolean, default: false},
     expand: {default: () => {}},
     isExpanded: {type: Boolean},
     isSelected: {type: Boolean},
     disabled: {type: Boolean, default: false},
     navigate: {default: () => []},
     is_mobile: {type: Boolean, default: false},
   },

   data: () => ({
   }),

   computed: {
     cols() {
       return this.columns.filter(
         c => (c.value != 'data-table-expand')
       );
     },
     canNavigate() {
      return this.navigate && this.unit.navigate_list;
     },
   },

   methods: {
     update_row(filters) {
       this.$emit('update', filters || new QFilters({}));
     },

     update_qunit(new_qunit) {
       this.$emit('update-qunit', new_qunit);
     },

     action_clicked() {
      this.$emit('click');
     },

     qunit_clicked() {
       if (! this.disabled)
         this.$emit('click');
     },

     navigate_to() {
      if (! this.disabled)
        this.$emit('navigate_to');
     },

     async download_file(qunit_file_value) {
       const row = qunit_file_value
         ? qunit_file_value
         : this.unit.current_public_version;
       const title = row.downloable_title || row.title
       try {
         const data = await QUnitAPI
           .getQUnitFile(
             this.unit._protected.centro,
             row.qunit_id,
             row.attribute,
             row.value,
             row.version,
             row.title,
             row.pmethod,
           );
         
         downloadFile(data, title);
         if (row.version) {
           this.update_qunit_after();
         }
       } catch (error) {
         console.log('handle_evidence', error);
       }
     },

    async update_qunit_after() {
      const updated_data = await QUnitAPI.getQUnit(this.unit._protected.centro, this.unit.uid);
      let new_qunit = new QUnit(updated_data);
      this.$emit('update-qunit-at', new_qunit);
     },
   },
 }
</script>
